module.exports = __webpack_public_path__ + "../../static/vue/img/swimmer.5bc723f8.gif";